export const ELEMENT_TYPE_ZH = {
  text: '文本',
  image: '图片',
  shape: '形状',
  line: '线条',
  chart: '图表',
  table: '表格',
}

export const MIN_SIZE = {
  text: 20,
  image: 20,
  shape: 1,
  chart: 200,
  table: 20,
}